// extracted by mini-css-extract-plugin
export default {"dropdown":"VBDropdown_dropdown__g5Eat"};